import {
  Box,
  CircularProgress,
  Container,
  Grid2,
  Typography,
  Chip,
} from "@mui/material";
import {
  LocationOn,
  Apartment,
  People,
  Phone,
  Restaurant,
  Bathtub,
  Security,
  EventNote,
  Comment,
  Business,
  Home,
  Map,
  Place,
  Male,
  Female,
  Wc,
  AutoStories,
  Work,
  Group,
  Groups,
} from "@mui/icons-material";
import ImageGrid from "../../components/properties/ImageGrid";
import LocationMap from "../../components/properties/LocationMap";
// import Booking from "../../components/properties/Booking";
import NotFound from "../../pages/NotFound";
import { useParams } from "react-router-dom";
import { useGetPropertyByIdQuery } from "./propertiesApiSlice";
import { useEffect } from "react";
import PropertyLocation from "../../components/properties/PropertyLocation";
import UserDetails from "../../components/users/UserDetails";
// import PublicUnitGrid from "../../components/units/PublicUnitGrid";
import PublicUnitGrid from "../../components/units/PublicUnitGridPG";
import PropertyLifestyle from "../../components/properties/PropertyLifestyle";

function PropertyDetails() {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  const {
    // Getting data and renaming it to properties
    data: property,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetPropertyByIdQuery(id);

  // Gender Logic
  const getGenderConfig = (gender) => {
    // const g = gender?.toLowerCase();
    if (gender === "male")
      return {
        label: "Men's PG",
        color: "info.main",
        icon: <Male />,
      };
    // return { label: "Men's PG", icon: <Male /> };
    if (gender === "female")
      return {
        label: "Women's PG",
        color: "#cf5e93",
        icon: <Female />,
      };
    return {
      label: "Co-ed (Separate Floors)",
      color: "inherit",
      icon: <Groups />,
    };
  };

  const genderConfig = getGenderConfig(property?.gender);

  // TenantType Logic
  const getTenantType = (tenantType) => {
    // const g = tenantType?.toLowerCase();
    if (tenantType === "students")
      return {
        label: "Students",
        color: "success.main",
        icon: <AutoStories />,
      };
    if (tenantType === "professionals")
      return {
        label: "Professionals",
        color: "success.main",
        icon: <Work />,
      };
    return {
      label: "Students & Professionals",
      color: "success.main",
      icon: <Group />,
    };
  };

  const tenantTypeConfig = getTenantType(property?.tenantType);

  if (!isLoading && property === undefined) {
    return <NotFound />;
  }

  let content;

  if (isLoading)
    content = (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (isError) {
    content = <p className="errmsg">{error?.data?.message}</p>;
  }

  if (isSuccess) {
    content = (
      <>
        {/* Title */}
        <Container sx={{ marginTop: 5, marginBottom: 3 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" }, // Column for small screens, row for larger
              alignItems: { xs: "center", sm: "center" }, // Center-align for small screens
              justifyContent: { xs: "center", sm: "space-between" }, // Space-between for larger screens
              gap: { xs: 2, sm: 0 }, // Add vertical spacing between buttons on small screens
              textAlign: { xs: "center", sm: "left" }, // Center-align text on small screens
            }}
          >
            <Box>
              <Typography variant="h4" component="h1">
                {property.title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                // mt: { xs: 1, sm: 0 },
                justifyContent: { xs: "center", sm: "flex-end" },
                // textAlign: { xs: "center", sm: "left" },
                // bgcolor: "green",
              }}
            >
              <Chip
                label={genderConfig.label}
                // color="secondary"
                sx={{
                  color: genderConfig.color,
                  borderColor: genderConfig.color,
                  "& .MuiChip-icon": { color: genderConfig.color },
                }}
                icon={genderConfig.icon}
                variant="outlined"
                // sx={{ fontWeight: "bold" }}
              />
              <Chip
                // icon={<Work />}
                label={tenantTypeConfig.label}
                // color="success"
                sx={{
                  color: tenantTypeConfig.color,
                  borderColor: tenantTypeConfig.color,
                  "& .MuiChip-icon": { color: tenantTypeConfig.color },
                  pl: 0.5,
                }}
                icon={tenantTypeConfig.icon}
                variant="outlined"
              />
            </Box>
          </Box>
        </Container>

        {/* Image Grid */}
        <Container sx={{ marginBottom: 5 }}>
          <ImageGrid data={property} />
        </Container>

        {/* Property Units */}
        <PublicUnitGrid property={property} />

        {/* Lifestyle (Amenities & Rules) */}
        <PropertyLifestyle
          amenities={property?.amenities}
          // amenities={propertyState?.houseRules || property?.houseRules}
          rules={property?.houseRules}
        />

        {/* Property Location */}
        <Container sx={{ marginBottom: 2 }}>
          <PropertyLocation data={property} />
        </Container>

        <Container sx={{ marginBottom: 5 }}>
          <Grid2 container size={{ xs: 12 }} spacing={3}>
            {/* Location and Map */}
            <Grid2 size={{ xs: 12 }}>
              <LocationMap data={property} />
            </Grid2>

            {/* Booking Dates */}
            {/* <Grid2 size={{ xs: 12, md: 4 }}>
              <Booking data={property} />
            </Grid2> */}
          </Grid2>
        </Container>

        {/* Owner Details */}
        <UserDetails property={property} />
      </>
    );
  }
  return content;
}

export default PropertyDetails;
